import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEmpty, get } from 'lodash';
import { setLanguage } from 'actions/language';
import { FlatButton, FontIcon, RaisedButton, TextField } from 'material-ui';
import { useForm, Controller } from 'react-hook-form/dist/index.ie11';
import KTitle from '../KJRN/KTitle';
import { changePassword } from '../../actions/account/resetPassword';

const ResetPassword = ({
  language, changeLang, router, submitRequest,
}) => {
  const {
    control,
    handleSubmit,
    getValues,
    errors,
  } = useForm();

  const onSubmit = ({ ConfirmPassword, NewPassword, Username }) => {
    const Code = get(router, 'params.code', '');
    const data = {
      ConfirmPassword,
      NewPassword,
      Username,
      Code,
    };
    submitRequest(data);
    router.push('/account');
  };

  return (
    <div style={{ maxWidth: 350, margin: 'auto' }}>
      <KTitle
        style={{
            marginLeft: 0,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
          }}
        title={<FormattedMessage id="pickNewPassword" />}
        subtitleStyle={{ margin: 0, fontSize: 12, lineHeight: '1' }}
        subtitle={(
          <React.Fragment>
            <FormattedMessage id="editPanel.pattern" />
          </React.Fragment>
          )}
      />
      <form>
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 24 }}>
          <Controller
            as={(
              <TextField
                fullWidth
                type="input"
                hintText={<FormattedMessage id="account.usernameemail" />}
                errorText={errors.Username ? <FormattedMessage id="editPanel.required" /> : ''}
              />
            )}
            name="Username"
            control={control}
            defaultValue=""
            style={{ marginBottom: 12 }}
            rules={{ required: true }}
          />
          <Controller
            as={(
              <TextField
                fullWidth
                type="password"
                hintText={<FormattedMessage id="account.password" />}
                errorText={errors.NewPassword ? <FormattedMessage id={`editPanel.${get(errors, 'NewPassword.type')}`} /> : ''}
              />
            )}
            name="NewPassword"
            control={control}
            defaultValue=""
            style={{ marginBottom: 12 }}
            rules={{
              required: true,
              pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[^a-zA-Z\d]).{12,}$/,
            }}
          />
          <Controller
            as={(
              <TextField
                fullWidth
                type="password"
                hintText={<FormattedMessage id="account.confirmPassword" />}
                errorText={errors.ConfirmPassword ? <FormattedMessage id={`editPanel.${get(errors, 'ConfirmPassword.type')}`} /> : ''}
              />
            )}
            name="ConfirmPassword"
            control={control}
            defaultValue=""
            style={{ marginBottom: 12 }}
            rules={{
              required: true,
              validate: {
                matchesPreviousPassword: (value) => {
                  const { NewPassword } = getValues();
                  return NewPassword === value || 'editPanel.passwordMissmatch';
                },
              },
             }}
          />
        </div>
        <RaisedButton
          fullWidth
          style={{ marginTop: 16 }}
          label={<FormattedMessage id="submit" />}
          disabled={!isEmpty(errors)}
          primary
          onClick={handleSubmit(data => onSubmit(data))}
        />
      </form>
      <div style={{ marginTop: 124, textAlign: 'center' }}>
        <FlatButton
          icon={<FontIcon style={{ marginRight: 12 }} className="material-icons">language</FontIcon>}
          labelPosition="before"
          onClick={() => {
            changeLang(language === 'en' ? 'is' : 'en');
          }}
          label={language === 'en' ? 'Íslenska' : 'English'}
        />
      </div>
    </div>
  );
};
ResetPassword.propTypes = {
  language: PropTypes.string,
  changeLang: PropTypes.func,
  router: PropTypes.object,
  submitRequest: PropTypes.func,
};
export default connect(
  ({ languageReducer }) => ({ ...languageReducer }),
  dispatch => ({
    submitRequest: data => dispatch(changePassword(data)),
    changeLang: language => dispatch(setLanguage(language)),
  }),
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/account/ResetPassword.js